/**
 * Created by asiulik on 2016-11-18.
 */

define([
    'jquery',
    'lodash',
    '../const/devicetypeconst',
    'eventEmitter/EventEmitter'
], function ($, _, DeviceTypeConst, EventEmitter) {

    function Layout() {

    }

    Layout.prototype = _.clone(EventEmitter.prototype);

    var proto = Layout.prototype;
    var $window = $(window);
    var LAZY_TIME = 300;

    proto.desktop = null;
    proto.mobile = null;

    function _init() {
        _checkType();
        _bindResize();
    }

    function _checkType() {

        var width = $window.innerWidth();

        proto.small = width <= DeviceTypeConst.SMALL.maxWidth;
        proto.medium = width >= DeviceTypeConst.MEDIUM.minWidth && width < DeviceTypeConst.MEDIUM.maxWidth;
        proto.large = width >= DeviceTypeConst.LARGE.minWidth && width < DeviceTypeConst.LARGE.maxWidth;
        proto.xl = width >= DeviceTypeConst.XL.minWidth;
        proto.mediumAndDown =  width <= DeviceTypeConst.MEDIUM.maxWidth;

        if(proto.small) proto.currentBreak = 'small';
        if(proto.medium) proto.currentBreak = 'medium';
        if(proto.large) proto.currentBreak = 'large';
        if(proto.xl) proto.currentBreak = 'xl';
        if(proto.mediumAndDown) proto.currentBreak = 'mediumAndDown';

        proto.emitEvent('reload');

    }

    function _bindResize() {
        var _lazyResize = _.debounce(_checkType, LAZY_TIME);
        $window.on('resize.Layout orientationchange.Layout', _lazyResize);
    }

    function _reload() {
        _checkType();
    }

    proto.init = _init;
    proto.reload = _reload;

    proto.isDesktopView = function(){
        return this.large || this.xl;
    };

    return Layout;

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/layout.js